<!-- 邀请链接 -->
<template>
  <popup-frame ref="invite" foreground-offset="top">
    <div :class="$style.invite">
      <div :class="$style.rules" v-html="inviteRuleHtml" />
      <div :class="$style.link">
        <button
          v-clipboard:copy="invitePrefix + inviteLink"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          :class="$style.copy"
        />
        <input v-model="inviteLink" readonly />
      </div>
    </div>
  </popup-frame>
</template>

<script>
import { mapGetters } from "vuex";
import { PopupFrame } from "@/components/widgets";

export default {
  name: "TheInviteLink",
  components: { PopupFrame },
  props: {
    invitePrefix: {
      type: String,
      default: ""
    },
    rulesConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["inviteCode"]),
    inviteLink() {
      const { origin, pathname } = location;
      return `${origin}${pathname}?code=${this.inviteCode}`;
    },
    inviteRuleHtml() {
      return this.rulesConfig.invite_rule || "";
    }
  },
  methods: {
    onCopy() {
      this.$toast("链接复制成功，快去邀请好友吧！");
    },
    onError() {
      this.$toast("复制失败，请换个浏览器试试！");
    },
    show() {
      this.$refs.invite.show();
    }
  }
};
</script>

<style lang="less" module>
@input-height: 0.81rem;

.invite {
  padding-top: 0.1rem;

  // 标题
  &::before {
    .size(5.16rem, 0.42rem);
    .background-fill("./images/invite-link-title.png");

    content: "";
    display: block;
    margin: 0 auto;
  }
}

.rules {
  width: 7rem;
  margin: 0.2rem auto 0;
  font-size: 0.28rem;
  text-align: left;
  list-style-position: inside;
}

.link {
  width: 8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.1rem;
  margin: 0.2rem auto 0;

  button {
    .size(3.07rem, @input-height);
    .background-fill("./images/invite-link-copy.png");

    flex-shrink: 0;
  }

  input {
    flex: 1;
    min-width: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: @input-height;
    padding: 0 0.75em;
    border: 0.02rem solid #d3b783;
    background-color: transparent;
    font-size: 0.3rem;
  }
}
</style>
